// remove from url: protocol, www., / - from the end

export const clearUrl = (url: string) => {
  return url
    .replace(/((http|https):\/\/)|(www\.)|(\/)$/g, '')
    .replace(/\/$/, '');
};
